import { render } from "./SketchP5.vue?vue&type=template&id=643df81e&scoped=true"
import script from "./SketchP5.vue?vue&type=script&lang=js"
export * from "./SketchP5.vue?vue&type=script&lang=js"

import "./SketchP5.vue?vue&type=style&index=0&id=643df81e&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643df81e"]])

export default __exports__